<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r.HSN_CODE+'  '+r.DDC_CODE+' - '+r.TRADE_NAME" [term]="t"></ngb-highlight>
</ng-template>
<app-page-header [heading]="'Add Temporary Sale'" [icon]="'fa-shopping-bag'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class="row">
    <div class="form-group col-lg-3">
      <label>Customer Name</label><span class="text-danger">&nbsp;*</span>
      <input [(ngModel)]="sale.patient_name" class="form-control " id="name" name="name" type="text">

    </div>
    <div class="form-group col-lg-3">
      <label>Date</label><span class="text-danger">&nbsp;*</span>
      <input (ngModelChange)="sale.sale_date = $event" [max]="getToday()" [ngModel]="sale.sale_date | date:'yyyy-MM-dd'"
             class="form-control " id="date" name="date" type="date">
    </div>
    <div class="form-group col-lg-3">
      <label>Slab</label>
      <select (change)="cleardata()" [(ngModel)]="sale.slab"
              class="form-control  custom-select custom-select-sm" id="sel_dr" name="sel_dr">
        <option value="">Select Slab</option>
        <option value="1">Slab A</option>
        <option value="2">Slab B</option>
        <option value="3">Slab C</option>
      </select>
    </div>
    <div class="form-group col-lg-3">
      <label>Payment Type</label>
      <div class="col-12">
        <label class="checkbox-inline">
          <input (click)="selectCoinPaymentType(1)" [checked]="sale.payment_type == 1" id="cash" name="payment_type"
                 type="radio"
                 value="1">&nbsp;&nbsp;Cash&nbsp;&nbsp;
        </label>&nbsp;&nbsp;&nbsp;
        <label class="checkbox-inline">
          <input (click)="selectCoinPaymentType(0)" [checked]="sale.payment_type == 0" id="card" name="payment_type"
                 type="radio"
                 value="0">&nbsp;&nbsp;Card&nbsp;&nbsp;
        </label>&nbsp;&nbsp;&nbsp;
        <label class="checkbox-inline">
          <input (click)="selectCoinPaymentType(2)" [checked]="sale.payment_type==2" id="cheque" name="payment_type"
                 type="radio"
                 value="2">&nbsp;&nbsp;Cheque&nbsp;&nbsp;
        </label>
        <label class="checkbox-inline">
          <input (click)="selectCoinPaymentType(3)" [checked]="sale.payment_type==3" id="bank" name="payment_type"
                 type="radio"
                 value="3">&nbsp;&nbsp;Bank
        </label>
        <ng-container *ngIf="sale.payment_type==2">
          <input [(ngModel)]="sale.chequeno" class="form-control " maxlength="20" name="cheque"
                 placeholder="Enter cheque number" type="text">
        </ng-container>
        <ng-container *ngIf="sale.payment_type == 0">
          <input [(ngModel)]="sale.chequeno" class="form-control " maxlength="20" name="cheque"
                 placeholder="Enter card number" type="text">
        </ng-container>
      </div>
    </div>
  </div>
  <hr>
  <div class="clearfix"></div>
  <div class=" form-group">
    <table class=" table   table-bordered">
      <thead>
      <tr class="text-center">
        <th width="1%">FOC</th>
        <th>#Sl</th>
        <th width="20%">Item Information<span class="text-danger">&nbsp;*</span></th>
        <th>Warehouse<span class="text-danger">&nbsp;*</span></th>
        <th>Ava.Qty</th>
        <th>UOM</th>
        <th>MRP</th>
        <th>Retail Price</th>
        <th>Quantity<span class="text-danger">&nbsp;*</span></th>
        <ng-container *ngIf="sale.state_code == 32">
          <th colspan="2">VAT <span>%</span> <br>
              <span class="pull-right">Amount</span></th>
        </ng-container>
        <th>Total<span class="text-danger">&nbsp;*</span></th>
        <th>*</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let i of utils.buildArray(sale_details.length)">
        <td class="text-center">
          <label>
            <input (change)="giveMarkFOC(i)"
                   [(ngModel)]="sale.mark_free_of_cost[i]"
                   [checked]="sale.mark_free_of_cost[i] == true"
                   name="mark_free_of_cost{{i}}"
                   type="checkbox"/>
          </label>
        </td>
        <td class="text-center">{{ 1 + i }}</td>
        <td>
          <input (selectItem)="set_item_medicine($event,i)" [(ngModel)]="sale.medicine_data[i]"
                 [class.is-invalid]="searchFailed" [inputFormatter]="formatter"
                 [ngModelOptions]="{standalone: true}" [ngbTypeahead]="medicine_search" [resultTemplate]="rt"
                 class="form-control" id="typeahead-http{{i}}"
                 placeholder="Search Particular Name...." style="height: 29px;"
                 type="text"/>
        </td>
        <td>
          <select (change)="availableqty(i)" [(ngModel)]="sale.warehouse_details_id_arr[i]"
                  class="form-control  custom-select custom-select-sm"
                  name="warehouse_id">
            <option value=''>Select Warehouse</option>
            <option *ngFor="let data of sale.warehouses_data[i];"
                    value="{{data.WAREHOUSE_STOCK_DETAIL_ID}}">{{ data.WAREHOUSE }}
            </option>
          </select>
        </td>
        <td>
          <input [(ngModel)]="sale.ava_quantity_arr[i]" [readOnly]="true"
                 class="form-control text-center "
                 name="ava_quantity_arr{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input [(ngModel)]="sale.uom_arr_name[i]" [readOnly]="true" class="form-control  "
                 name="uom_arr_name{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input [(ngModel)]="sale.MRP[i]" [readOnly]="true" class="form-control text-right "
                 name="MRP{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input (change)="totalAmount();totalprice();" (focusout)="totalAmount();totalprice()"
                 [(ngModel)]="sale.unitprice_arr[i]" [disabled]="sale.mark_free_of_cost[i] == true"
                 class="form-control text-right " id="unitprice_arr{{i}}" name="unitprice_arr{{i}}"
                 type="text">
        </td>
        <td>
          <input (focusout)="totalprice();totalAmount()" [(ngModel)]="sale.quantity_arr[i]"
                 class="form-control  "
                 maxlength="7" name="quantity_arr{{i}}" type="text">
        </td>
        <ng-container>
          <td>
            <input (focusout)="totalprice()" [(ngModel)]="sale.vat_arr[i]" [readOnly]="true"
                   class="form-control text-right " name="vat_arr{{i}}" tabindex="-1"
                   type="text">
          </td>
          <td>
            <input (focusout)="totalprice()" [(ngModel)]="sale.vatamt_arr[i]" [readOnly]="true"
                   class="form-control text-right " name="vat_arr{{i}}" tabindex="-1"
                   type="text">
          </td>
        </ng-container>
        <td>
          <input [(ngModel)]="sale.total_arr[i]" [readOnly]="true" class="form-control text-right "
                 name="total_arr{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <button (click)="addrow(i)" *ngIf="i == sale_details.length-1" alt="Add New data"
                  class="btn btn-success btn-sm "
                  title="Add New data" type="button"><i class="fa fa-plus"
                                                        style="color: white;"></i></button>
          <button (click)="deleterow(i)" *ngIf="i  != sale_details.length-1" alt="Delete data"
                  class="btn btn-danger  btn-sm "
                  title="Delete data" type="button"><i class="fa fa-trash"
                                                       style="color: white;"></i>
          </button>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <ng-container *ngIf="sale.state_code == 32">
        <tr>
          <td colspan="12" style="text-align: right"><label>Gross Total&nbsp;&nbsp;&nbsp;</label></td>
          <td style="text-align: right;width:10%"><label>{{ total_amount | number : '1.2-2' }}</label></td>
        </tr>
        <tr>
          <td colspan="6" style="text-align: right"><label>Discount&nbsp;&nbsp;&nbsp; </label></td>
          <input (focusout)="total()" [(ngModel)]="sale.discount" class="form-control text-right"
                 maxlength="8" name="dis_arr" style="height:34px" type="text">
          <td colspan="2" style="text-align: right"><label>Freight/Handling charge&nbsp;&nbsp; </label></td>
          <input (focusout)="total()" [(ngModel)]="sale.freight_charge" class="form-control text-right "
                 maxlength="9"
                 name="freight" style="height:34px" type="text">
          <td colspan="2" style="text-align: right"><label>Net Total&nbsp;&nbsp;&nbsp;</label></td>
          <td style="text-align: right;width:10%"><label>{{ net_total | number : '1.2-2' }}</label></td>
        </tr>
      </ng-container>
      </tfoot>
    </table>
    <div class="clearfix"></div>
  </div>
  <div class="clearfix"></div>
  <div class="row">
    <div class="col-lg-7 pull-right">
      <button (click)="saveTemporarySale()" *ngIf="user_rights.ADD == '1'"
              class="btn  btn-info btn-sm ng-star-inserted"
              type="button">&nbsp;Save&nbsp;
      </button>&nbsp;&nbsp;
    </div>
  </div>
</div>
